import { useEffect, useState, useContext } from "react";
import CreateRoleMethod from "./components/CreateRoleMethod";
import RoleMethodTable from "./components/RoleMethodTable";
import { getRolePermission,getRolePermissionSecond } from "api/graphQL_role";
import { getSingleRole } from "api//graphQL_role";
import { getId } from "utils/auth";
import { ClientContext } from "ClientProvider";

export type PaymentMethodRowObj = {
  id: string;
  name: string;
  logo: string;
  payments: any;
  dashboard: any;
  client: any;
  organization: any;
  payment: any;
  payment_method: any;
  user: any;
  role: any;
  subscription: any;
  token: any;
  super_admin: any;
  settlement: any;
  blacklist: any;
  settings: any;
  customers: any;
  whitelist: any;
  api: any;
  authorization: boolean;
  payout: any;
  api_request_logs: any;
  kyc_velocity: any;
  crypto: any;
  fiat: any;
  audit_logs: any;
  is_active: boolean;
  role_name: any;
  users: [];
};

const Role = () => {
  const [roleData, setRoleData] = useState<any>([]);
  const [allRoleData, setAllRoleData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);

  const fetchRole = () => {
    setIsLoading(true);
    if (pageSize === null || pageSize === undefined) {
      setIsLoading(false);
      return;
    }
    getRolePermission(page, pageSize, searchTexts)
      .then((data) => {
        setRoleData(data?.[0] ?? []);
        setTotalPage(data?.[1]?.total_pages);
        setTotalItems(data?.[1]?.total_items);
        setCurrentPage(data?.[1]?.current_page);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const fetchAllRole = () => {
    getRolePermissionSecond(1, 5000,"")
      .then((data) => {
        setAllRoleData(data?.[0] ?? []);
      })
      .catch(() => {})
      .finally(() => {});
  };

  const fetchSingleRole = () => {
    getSingleRole(getId())
      .then((data) => setSingleRoleData(data ?? []))
      .catch(() => {});
  };

  useEffect(() => {
    fetchRole();
    fetchAllRole();
  }, [page, pageSize, searchTexts]);

  useEffect(() => {
    fetchSingleRole();
    fetchAllRole();
  }, []);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
      setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  useEffect(() => {
    setPageSize(50);
  }, [searchTexts]);

  return (
    <div className="rl-root">
      {/* Page header */}
      <div className="rl-page-header">
        <div className="rl-page-title-block">
          <div className="rl-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <div>
            <h1 className="rl-page-heading">Roles & Permissions</h1>
            <p className="rl-page-sub">Manage roles and module-level access control</p>
          </div>
        </div>
        <div className="rl-page-actions">
          <CreateRoleMethod
            fetchRole={fetchRole}
            singleRoleData={singleRoleData}
            fetchSingleRole={fetchSingleRole}
          />
        </div>
      </div>

      <RoleMethodTable
        pageSize={pageSize}
        setPageSize={setPageSize}
        tableData={roleData}
        allRoleData={allRoleData}
        fetchRole={fetchRole}
        isLoading={isLoading}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        singleRoleData={singleRoleData}
        onValueChange={serchboxValueChange}
        fetchSingleRole={fetchSingleRole}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .rl-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-height: 100vh;
          display: flex; flex-direction: column; gap: 20px;
        }
        .rl-page-header {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 16px;
        }
        .rl-page-title-block { display: flex; align-items: center; gap: 14px; }
        .rl-page-icon {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg,#fff1f2,#ffe4e6);
          border: 1.5px solid #fecdd3;
          display: flex; align-items: center; justify-content: center;
          color: #e11d48; flex-shrink: 0;
        }
        .rl-page-heading { font-size: 20px; font-weight: 800; color: #0f172a; letter-spacing: -0.4px; margin-bottom: 2px; line-height: 22px; }
        .rl-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
        .rl-page-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
        @media (max-width: 600px) {
          .rl-root { padding: 14px; gap: 14px; }
          .rl-page-header { flex-direction: column; align-items: flex-start; }
        }
      `}</style>
    </div>
  );
};

export default Role;